import React from 'react';
import { Field, CccisdInput, CccisdToggle, CccisdWysiwyg } from 'cccisd-formik';
import { widgetBuilder } from 'cccisd-laravel-appdefs';

export const initialValues = {
    show: true,
    title: 'Points Chart',
    description: '',
};

const Component = props => {
    return (
        <div>
            <Field name="show" component={CccisdToggle} label="Show Points Chart?" />
            <Field name="title" component={CccisdInput} label="Title" />
            <Field name="description" component={CccisdWysiwyg} label="Description" />
        </div>
    );
};

export default widgetBuilder({ initialValues })(Component);
